import { apiRequest } from './apiClient';

const BASE = '/api/on-servis-kayitlari';

export async function sendOnServisOtp({ musteriAd, musteriSoyad, telefon }) {
  return apiRequest(`${BASE}/otp/gonder`, {
    method: 'POST',
    body: { musteriAd, musteriSoyad, telefon },
  });
}

export async function verifyOnServisOtp({ telefon, kod }) {
  return apiRequest(`${BASE}/otp/dogrula`, {
    method: 'POST',
    body: { telefon, kod },
  });
}

export async function createOnServisKaydi({ dogrulamaToken, icerikId, seriNumarasi }) {
  return apiRequest(BASE, {
    method: 'POST',
    body: { dogrulamaToken, icerikId, seriNumarasi },
  });
}

export async function fetchMyOnServisKayitlari({ sayfa = 1, limit = 10 } = {}) {
  const params = new URLSearchParams({ sayfa: String(sayfa), limit: String(limit) });
  return apiRequest(`${BASE}/benim?${params.toString()}`);
}

export async function fetchOnServisKayitlari({
  sayfa = 1,
  limit = 20,
  durum,
  arama,
  baslangic,
  bitis,
} = {}) {
  const params = new URLSearchParams({ sayfa: String(sayfa), limit: String(limit) });
  if (durum) params.set('durum', durum);
  if (arama) params.set('arama', arama);
  if (baslangic) params.set('baslangic', baslangic);
  if (bitis) params.set('bitis', bitis);
  return apiRequest(`${BASE}?${params.toString()}`);
}

export async function fetchOnServisKaydiDetay(id) {
  return apiRequest(`${BASE}/${id}`);
}

export async function fetchOnServisIstatistik({ baslangic, bitis, durum, arama } = {}) {
  const params = new URLSearchParams();
  if (baslangic) params.set('baslangic', baslangic);
  if (bitis) params.set('bitis', bitis);
  if (durum) params.set('durum', durum);
  if (arama) params.set('arama', arama);
  const qs = params.toString();
  return apiRequest(`${BASE}/istatistik${qs ? `?${qs}` : ''}`);
}

export async function updateOnServisKaydiDurum(id, durum) {
  return apiRequest(`${BASE}/${id}/durum`, {
    method: 'PATCH',
    body: { durum },
  });
}

export async function fetchTaslakByOnServis(onServisKaydiId) {
  return apiRequest(`/api/service-records/taslak/by-on-servis/${onServisKaydiId}`);
}
